import { c as _c } from "react/compiler-runtime";
import Typography from '@classify/react-core-components/Typography';
import withStyles from '@mui/styles/withStyles';
import { palette } from '@classify/react-core-components/Theme';
import styles from './styles';
export const ListItem = t0 => {
  const $ = _c(59);
  let illustration;
  let otherProps;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let title;
  if ($[0] !== t0) {
    ({
      overlineLabel: t1,
      overlineLabelColor: t2,
      children: t3,
      classes: t4,
      className: t5,
      component: t6,
      illustration,
      shouldHandleHover: t7,
      sublineLabel: t8,
      title,
      titleProps: t9,
      titleComponent: t10,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = illustration;
    $[2] = otherProps;
    $[3] = t1;
    $[4] = t10;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
    $[13] = title;
  } else {
    illustration = $[1];
    otherProps = $[2];
    t1 = $[3];
    t10 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
    title = $[13];
  }
  const overlineLabel = t1 === undefined ? "" : t1;
  const overlineLabelColor = t2 === undefined ? palette.text.caption : t2;
  const children = t3 === undefined ? "" : t3;
  let t11;
  if ($[14] !== t4) {
    t11 = t4 === undefined ? {} : t4;
    $[14] = t4;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const classes = t11;
  const className = t5 === undefined ? "" : t5;
  const Component = t6 === undefined ? "li" : t6;
  const shouldHandleHover = t7 === undefined ? false : t7;
  const sublineLabel = t8 === undefined ? null : t8;
  let t12;
  if ($[16] !== t9) {
    t12 = t9 === undefined ? {} : t9;
    $[16] = t9;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const titleProps = t12;
  const titleComponent = t10 === undefined ? null : t10;
  const t13 = `${className} ${classes.root}`;
  const t14 = `${classes.listItemInner} ${shouldHandleHover ? classes.listItemInnerHover : ""}`;
  let t15;
  if ($[18] !== overlineLabelColor) {
    t15 = {
      backgroundColor: overlineLabelColor
    };
    $[18] = overlineLabelColor;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== classes.illustrationContainer || $[21] !== illustration || $[22] !== t15) {
    t16 = <div className={classes.illustrationContainer} style={t15}>{illustration}</div>;
    $[20] = classes.illustrationContainer;
    $[21] = illustration;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== classes.overlineLabel || $[25] !== overlineLabel || $[26] !== overlineLabelColor) {
    t17 = overlineLabel && <Typography className={classes.overlineLabel} variant="overline" style={{
      color: overlineLabelColor
    }}>{overlineLabel}</Typography>;
    $[24] = classes.overlineLabel;
    $[25] = overlineLabel;
    $[26] = overlineLabelColor;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      display: "block"
    };
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== classes.title || $[30] !== title || $[31] !== titleComponent || $[32] !== titleProps) {
    t19 = <Typography className={classes.title} variant="h6" component={titleComponent} sx={t18} {...titleProps}>{title}</Typography>;
    $[29] = classes.title;
    $[30] = title;
    $[31] = titleComponent;
    $[32] = titleProps;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== classes.sublineLabel || $[35] !== sublineLabel) {
    t20 = sublineLabel && <div className={classes.sublineLabel}>{sublineLabel}</div>;
    $[34] = classes.sublineLabel;
    $[35] = sublineLabel;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== children || $[38] !== classes.content) {
    t21 = typeof children === "string" && <Typography className={classes.content} variant="body1">{children}</Typography>;
    $[37] = children;
    $[38] = classes.content;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== children || $[41] !== classes.content) {
    t22 = typeof children !== "string" && <div className={classes.content}>{children}</div>;
    $[40] = children;
    $[41] = classes.content;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== classes.informationContainer || $[44] !== t17 || $[45] !== t19 || $[46] !== t20 || $[47] !== t21 || $[48] !== t22) {
    t23 = <div className={classes.informationContainer}>{t17}{t19}{t20}{t21}{t22}</div>;
    $[43] = classes.informationContainer;
    $[44] = t17;
    $[45] = t19;
    $[46] = t20;
    $[47] = t21;
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t14 || $[51] !== t16 || $[52] !== t23) {
    t24 = <div className={t14}>{t16}{t23}</div>;
    $[50] = t14;
    $[51] = t16;
    $[52] = t23;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== Component || $[55] !== otherProps || $[56] !== t13 || $[57] !== t24) {
    t25 = <Component className={t13} {...otherProps}>{t24}</Component>;
    $[54] = Component;
    $[55] = otherProps;
    $[56] = t13;
    $[57] = t24;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  return t25;
};
export default withStyles(styles)(ListItem);